import { ArrowRight2, MessageRemove } from 'iconsax-react';

import { Button } from '@src/design-system/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@src/design-system/dialog';
import TiclickTable from '@src/design-system/molecules/ticlick-table';

import { useFailedRemindersDialogTable } from './use-failed-reminders-dialog-table';
import reminderLogsApi from '@src/features/reminders/services/reminder-logs-api';
import { REMINDER_LOG_STATUSES } from '@src/shared/types/reminder';

export const FailedReminders = () => {
  const { data: failedReminders, isPending } = reminderLogsApi.useFetch({
    status: [REMINDER_LOG_STATUSES.failed],
    page_size: 1,
  });

  return (
    <div className='flex items-center justify-between p-4 bg-red-100 rounded-2xl'>
      <p className='font-medium text-red-500 flex items-center gap-2'>
        <MessageRemove
          className='text-red-500'
          size={24}
          variant='Bold'
        />
        {isPending
          ? 'Loading failed reminders…'
          : failedReminders.count
            ? `${failedReminders.count} Failed reminders need attention - resend to avoid missed follow-Ups`
            : 'No failed reminders need attention right now.'}
      </p>

      <Dialog>
        <DialogTrigger asChild>
          <Button className='h-[40px] px-2.5 rounded-xl text-sm font-semibold gap-1 bg-red-500 hover:bg-red-600'>
            Failed Reminders
            <ArrowRight2 size={16} />
          </Button>
        </DialogTrigger>
        <DialogContent
          className='max-w-[78%] flex flex-col overflow-hidden p-0 gap-0 sm:rounded-xl'
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <FieldReminderTable />
        </DialogContent>
      </Dialog>
    </div>
  );
};

const FieldReminderTable = () => {
  const { table, actions } = useFailedRemindersDialogTable();

  return (
    <>
      <DialogHeader className='rounded-none border-b border-primary-100 bg-white shrink-0'>
        <DialogTitle className='text-xl font-semibold text-gray-1000'>
          Failed Reminders
        </DialogTitle>
      </DialogHeader>
      <DialogBody className='flex flex-1 flex-col min-h-0 overflow-auto p-4'>
        <TiclickTable
          table={table}
          actions={actions}
          props={{ searchInputProps: { queryKey: 'name' } }}
        />
      </DialogBody>
    </>
  );
};
